import View from './BankingButton.view';

export default View;
